import React from 'react';
import {
    Modal, ModalHeader, ModalBody, Table
} from 'reactstrap';
import Moment from 'react-moment';
import 'moment-timezone';

export const ModalLogUsuario = ({ modal, toggle, log, usuario }) => {

    return (         
        <div>
            <Modal isOpen={modal} toggle={toggle} size="xl" >
                <ModalHeader toggle={toggle}>Histórico do Usuário {usuario}</ModalHeader>
                <ModalBody>
                    <Table className="small" size="sm" hover striped bordered responsive >
                        <thead>
                            <tr>
                                <th>Data/Hora</th>
                                <th>Fazenda</th>
                                <th>Tabela</th>
                                <th>Campo</th>
                                <th>Valor Antigo</th>
                                <th>Valor Novo</th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                log.map(n => {
                                    return (
                                        <tr key={n.id}>
                                            <td style={{ align: "left" }}><Moment format="DD/MM/YYYY HH:mm">{n.data_alteracao}</Moment></td>
                                            <td style={{ align: "left" }}>{n.fazenda}</td>
                                            <td style={{ align: "left" }}>{n.tabela}</td>
                                            <td style={{ align: "left" }}>{n.campo}</td>
                                            <td style={{ align: "left" }}>{n.ValorAntigo}</td>
                                            <td style={{ align: "left" }}>{n.ValorNovo}</td>
                                        </tr>
                                    );
                                })
                            }
                        </tbody>
                    </Table>
                </ModalBody>
            </Modal>
        </div>
    );

};